import i18n from 'modules/core/lib/i18n'

export const USER = 'user'
export const RELATIVE_ROLE = 'relative role'
export const MANAGER = 'manager'
const TIMEOFF_MANAGER = 'timeoffmanager'
const ADMINS = 'admins'
export const TEAM_LEAD = 'teamlead'
export const TEAM = 'Team'
export const GROUPABLE_ACTIVE = 'groupableactive'
export const MEMBERS = 'members'
const SELF_APPROVAL = 'self'
export const APRROVER_STATUS = {
  pending: 'pending',
}

const ROLE_INITIALS = {
  timeoffmanager: 'T S.',
  manager: 'M N',
  admins: 'A',
  Team: 'T',
  groupableactive: 'T',
  teamlead: 'T L',
  self: 'S A',
}

export const approverTypeOptions = () => [
  {
    label: i18n.t('settings.approvals.approval_level.relative_role'),
    value: RELATIVE_ROLE,
  },
  {
    label: i18n.t('settings.approvals.approval_level.user'),
    value: USER,
  },
]

export const approverRoleOptions = () => [
  {
    label: i18n.t('settings.approvals.approval_level.self_approval'),
    value: SELF_APPROVAL,
  },
  {
    label: i18n.t('settings.approvals.approval_level.manager'),
    value: MANAGER,
  },
  {
    label: i18n.t('settings.approvals.approval_level.timeoff_supervisor'),
    value: TIMEOFF_MANAGER,
  },
  {
    label: i18n.t('settings.approvals.approval_level.admins'),
    value: ADMINS,
  },
  {
    label: i18n.t('settings.approvals.approval_level.team'),
    value: GROUPABLE_ACTIVE,
  },
  {
    label: i18n.t('settings.approvals.approval_level.team_lead'),
    value: TEAM_LEAD,
  },
]

export const SELECTION_CRITERIA = {
  configuredapprover: 'configuredapprover',
  delegateapprover: 'delegateapprover',
  managerasfallback: 'managerasfallback',
  firstadminasfallback: 'firstadminasfallback',
  adminasfallback: 'adminasfallback',
  ownernoadmins: 'ownernoadmins',
}

export const roleName = (role: string) => {
  switch (role) {
    case 'timeoffmanager':
      return i18n.t('settings.approvals.approval_level.timeoff_supervisor')
    case 'manager':
      return i18n.t('settings.approvals.approval_level.manager')
    case 'admins':
      return i18n.t('settings.approvals.approval_level.admins')
    case 'Team':
      return i18n.t('settings.approvals.approval_level.team')
    case 'groupableactive':
      return i18n.t('settings.approvals.approval_level.team')
    case 'teamlead':
      return i18n.t('settings.approvals.approval_level.team_lead')
    case 'self':
      return i18n.t('settings.approvals.approval_level.self_approval')
    default:
      return ''
  }
}

export const roleInitials = (role: string) => {
  switch (role) {
    case 'timeoffmanager':
      return ROLE_INITIALS.timeoffmanager
    case 'manager':
      return ROLE_INITIALS.manager
    case 'admins':
      return ROLE_INITIALS.admins
    case 'Team':
      return ROLE_INITIALS.Team
    case 'groupableactive':
      return ROLE_INITIALS.groupableactive
    case 'teamlead':
      return ROLE_INITIALS.teamlead
    case 'self':
      return ROLE_INITIALS.self
    default:
      return ''
  }
}
